import { EducationalProps } from "../../types/interfaces";
import { GenderType } from "../../utils/enums";
import EducationalStepsWrapper from "./EducationalStepsWrapper";
import LanguageContextProvider from "../../utils/context/languageContext";
import { ConfigProvider } from "../../utils/context/configContext";

export const Educational: React.FC<EducationalProps> = ({
  sections = [],
  config,
  gender = GenderType.Male,
  onComplete,
  isCustom,
  startStep,
}) => {
  return (
    <LanguageContextProvider>
      <ConfigProvider config={config}>
        <EducationalStepsWrapper
          sections={sections}
          gender={gender}
          onComplete={onComplete}
          isCustom={isCustom}
          startStep={startStep}
        />
      </ConfigProvider>
    </LanguageContextProvider>
  );
};
